import type { Language } from "@app/constants";

interface Message {
	boldText: string;
	subtext: string;
}

type MessageData = {
	[key in Language]: Message;
};

const messages: MessageData = {
	en: {
		boldText: "Registrations paused",
		subtext:
			"Registrations are currently paused until we find a solution to continue trading. You will be notified as soon as trading resumes.",
	},
};

export default messages;
